import { render } from "./ClothesSection.vue?vue&type=template&id=15a41db8&scoped=true"
import script from "./ClothesSection.vue?vue&type=script&lang=js"
export * from "./ClothesSection.vue?vue&type=script&lang=js"

import "./ClothesSection.vue?vue&type=style&index=0&id=15a41db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a41db8"]])

export default __exports__